<template>
	<button type="submit" class="btn btn-submit-icon-text" :disabled="loading">
		<svgicon :name="icon" :fill="false" class="icon"/>
		<spinner v-if="loading" size="small" class="spinner"/>
		<span v-else class="text">
			<slot/>
		</span>
	</button>
</template>

<script>
export default {
	props: [
		'icon',
		'loading'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/ButtonSubmitIconText.vue